import React, { useState, useEffect, useRef } from "react";
import "./IconicGallery.css";
import OurCompanies from "../Home/OurCompanies";
import express from "../../../src/assets/gallery/express.png";
import greenland from "../../../src/assets/gallery/greenland.jpg";
import furniture from "../../../src/assets/gallery/furniture.jpg";
import motors from "../../../src/assets/gallery/motors.jpg";
import CommonBannar from "../IconicFAQ/CommonBannar";

import gallary1 from "../../../src/assets/gallary-image/galary1.jpeg";
import gallary2 from "../../../src/assets/gallary-image/galary2.jpeg";
import gallary3 from "../../../src/assets/gallary-image/galary3.jpeg";
import gallary4 from "../../../src/assets/gallary-image/galary4.jpeg";
import gallary5 from "../../../src/assets/gallary-image/galary5.jpeg";
import gallary7 from "../../../src/assets/gallary-image/galary7.jpeg";
import bulders1 from "../../assets/gallary-image/iconic and bulders.jpeg";
// import bulders2 from "../../assets/gallary-image/bulders.jpeg";
import blog_img_05 from "../../assets/gallary-image/blog_img_05.jpeg";
import blog_img_16 from "../../assets/gallary-image/galary2.jpeg";
import blog_img_14 from "../../assets/gallary-image/galary1.jpeg";
import blog_img_07 from "../../assets/gallary-image/blog_img_07.jpeg";
import blog_img_09 from "../../assets/gallary-image/blog_img_09.jpeg";

const IconicGallery = () => {
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [hoveredCard, setHoveredCard] = useState(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [activePhoto, setActivePhoto] = useState(null);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const galleryImages = [
    { id: 1, src: gallary1, alt: "Gallery 1" },
    { id: 2, src: gallary2, alt: "Gallery 2" },
    { id: 3, src: gallary3, alt: "Gallery 3" },
    { id: 4, src: gallary4, alt: "Gallery 4" },
    { id: 5, src: gallary5, alt: "Gallery 5" },
    { id: 7, src: gallary7, alt: "Gallery 7" },
    { id: 8, src: bulders1, alt: "bulders 1" },
    { id: 9, src: blog_img_09, alt: "blog_img_09" },
    { id: 10, src: blog_img_05, alt: "blog_img_05" },
    { id: 11, src: blog_img_16, alt: "blog_img_16" },
    { id: 12, src: blog_img_14, alt: "blog_img_14" },
    { id: 13, src: blog_img_07, alt: "blog_img_07" },
  ];

  const companies = [
    {
      id: 1,
      name: "Iconic Express",
      category: "logistics",
      tagline: "Swift & Reliable Delivery Solutions",
      description: "Leading courier and logistics services across the nation",
      image: express,
      color: "#bd06b3",
      galaryLink: "https://iconicexpressbd.com",
    },
    {
      id: 2,
      name: "Iconic Greenland",
      category: "real-estate",
      tagline: "Building Dreams, Creating Homes",
      description: "Premium real estate development and property management",
      image: greenland,
      color: "#00bfff",
      galaryLink: "https://iconicgreenland.com/gallery",
    },
    {
      id: 3,
      name: "Iconic Soft Ltd",
      category: "technology",
      tagline: "Innovating Digital Excellence",
      description: "Cutting-edge software solutions and IT services",
      image:
        "https://images.unsplash.com/photo-1551434678-e076c223a692?w=800&q=80",
      color: "#bd06b3",
      galaryLink: "https://iconicsoftltd.com/projects",
    },
    {
      id: 4,
      name: "Iconic Furniture",
      category: "retail",
      tagline: "Crafting Comfort & Style",
      description: "Exquisite furniture collections for modern living",
      image: furniture,
      color: "#00bfff",
      galaryLink: "https://iconicfurniturebd.com/collections/all-furniture",
    },
    {
      id: 5,
      name: "Iconic Hajj",
      category: "services",
      tagline: "Sacred Journeys, Sacred Trust",
      description: "Premium Hajj and Umrah travel packages and guidance",
      image:
        "https://i.pinimg.com/736x/a7/55/83/a75583a11db54aed125e53531025c54d.jpg",
      color: "#bd06b3",
      galaryLink: "#",
    },
    {
      id: 6,
      name: "Iconic Motors",
      category: "automotive",
      tagline: "Driving Excellence Forward",
      description: "Premium automotive sales and service center",
      image: motors,
      color: "#00bfff",
      galaryLink: "https://iconicmotorsltd.com/#gallery",
    },
  ];

  const categories = [
    { id: "all", name: "All Companies", count: companies.length },
    {
      id: "logistics",
      name: "Iconic Express",
      count: companies.filter((c) => c.category === "logistics").length,
    },
    {
      id: "real-estate",
      name: "Iconic Greenland",
      count: companies.filter((c) => c.category === "real-estate").length,
    },
    {
      id: "technology",
      name: "Iconic Soft Ltd.",
      count: companies.filter((c) => c.category === "technology").length,
    },
    {
      id: "retail",
      name: "Iconic Furniture",
      count: companies.filter((c) => c.category === "retail").length,
    },
    {
      id: "services",
      name: "Iconic Hajj",
      count: companies.filter((c) => c.category === "services").length,
    },
    {
      id: "automotive",
      name: "Iconic Motors",
      count: companies.filter((c) => c.category === "automotive").length,
    },
  ];

  const filteredCompanies =
    selectedCategory === "all"
      ? companies
      : companies.filter((company) => company.category === selectedCategory);

  const currentCategoryName =
    categories.find((c) => c.id === selectedCategory)?.name || "All Companies";

  return (
    <div className="ga-gallery-container">
      {/* Banner Section */}
      <CommonBannar
        title={"OUR PORTFOLIO OF EXCELLENCE"}
        des={
          "A diverse ecosystem of businesses united by innovation, quality, and trust"
        }
      />

      {/* Photo Gallery Section */}
      <section className="ga-photo-gallery-section">
        <div className="ga-photo-gallery-container">
          <h2 className="ga-photo-gallery-title">PHOTO GALLERY</h2>
          <div className="ga-photo-gallery-grid">
            {galleryImages.map((img) => (
              <div
                key={img.id}
                className="ga-photo-card"
                onClick={() => setActivePhoto(img.src)}
              >
                <img src={img.src} alt={img.alt} className="ga-photo-img" />
                <div className="ga-photo-overlay">
                  <span>View Image</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Popup Modal Component */}
      {activePhoto && (
        <div
          className="ga-photo-modal-overlay"
          onClick={() => setActivePhoto(null)}
        >
          <div
            className="ga-photo-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="ga-photo-modal-close"
              onClick={() => setActivePhoto(null)}
            >
              &times;
            </button>
            <img
              src={activePhoto}
              alt="Gallery Preview"
              className="ga-photo-modal-img"
            />
          </div>
        </div>
      )}

      {/* Category Filter Dropdown */}
      <section className="ga-filter-section">
        <div className="ga-filter-container">
          <div className="ga-filter-header">
            <h3 className="ga-filter-title">BROWSE BY CATEGORY</h3>
          </div>

          <div className="ga-custom-dropdown-wrapper" ref={dropdownRef}>
            <div
              className={`ga-custom-dropdown-selected ${isDropdownOpen ? "open" : ""}`}
              onClick={() => setIsDropdownOpen(!isDropdownOpen)}
            >
              <span>{currentCategoryName}</span>
              <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                style={{
                  transform: isDropdownOpen ? "rotate(180deg)" : "rotate(0deg)",
                  transition: "transform 0.3s ease",
                }}
              >
                <path
                  d="M2.5 4.5L6 8L9.5 4.5"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>

            {isDropdownOpen && (
              <ul className="ga-dropdown-options">
                {categories.map((category) => (
                  <li
                    key={category.id}
                    className={`ga-dropdown-item ${selectedCategory === category.id ? "active" : ""}`}
                    onClick={() => {
                      setSelectedCategory(category.id);
                      setIsDropdownOpen(false);
                    }}
                  >
                    <span className="ga-item-name">{category.name}</span>
                    <span className="ga-item-count">({category.count})</span>
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      </section>

      {/* Gallery Grid */}
      <div className="ga-gallery-grid">
        {filteredCompanies.map((company, index) => (
          <div
            key={company.id}
            className={`ga-gallery-card ${hoveredCard === company.id ? "ga-hovered" : ""}`}
            onMouseEnter={() => setHoveredCard(company.id)}
            onMouseLeave={() => setHoveredCard(null)}
            style={{ animationDelay: `${index * 0.1}s` }}
          >
            <div className="ga-card-image-wrapper">
              <img
                src={company.image}
                alt={company.name}
                className="ga-card-image"
              />
            </div>

            <div className="ga-card-content">
              <div className="ga-card-header">
                <h3 className="ga-card-title">{company.name}</h3>
                <div
                  className="ga-card-accent"
                  style={{ background: company.color }}
                ></div>
              </div>

              <p className="ga-card-tagline">{company.tagline}</p>
              <p className="ga-card-description">{company.description}</p>

              <a
                href={company.galaryLink}
                rel="noreferrer"
                target="_blank"
                className="ga-card-button"
                style={{ borderColor: company.color, color: company.color }}
              >
                <span>Explore More</span>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path
                    d="M6 12L10 8L6 4"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </a>
            </div>

            <div
              className="ga-card-badge"
              style={{ background: company.color }}
            >
              <span className="ga-badge-text">ICONIC</span>
            </div>
          </div>
        ))}
      </div>

      <div className="ga-our-company">
        <OurCompanies />
      </div>
    </div>
  );
};

export default IconicGallery;
